import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';

const initialData = {
  systemnotesStatus: null,
  systemisLoading: false,
  systemerrorMsg: null,
  systemsuccessMsg: null,
};

const slice = createSlice({
  name: 'systemNote',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.systemisLoading = true;
      state.systemerrorMsg = null;
    },
    postSystemNotesData: (state, action) => {
      state.systemnotesStatus = action.payload.status;
      state.systemisLoading = false;
      state.systemerrorMsg = null;
      state.systemsuccessMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.systemerrorMsg = action.payload;
      state.systemisLoading = false;
    },
    fetchSuccess: (state, action) => {
      state.systemsuccessMsg = action.payload;
      state.systemisLoading = false;
    },
    resetStatus: (state) => {
      state.systemnotesStatus = null;
      state.systemerrorMsg = null;
    },
    resetMsg: (state) => {
      state.systemsuccessMsg = null;
      state.systemerrorMsg = null;
      state.systemisLoading = false;
      state.systemnotesStatus = null;
    },
  },
});
const {postSystemNotesData, fetchStart, resetMsg, fetchError, resetStatus} = slice.actions;

export default slice.reducer;

export const systempostNotesInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/formulanotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const systempostNotesFilterInformation = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/save/filternotes`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetPostStatus = () => {
  return (dispatch) => {
    dispatch(resetStatus());
  };
};
export const systemNotesResetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
